import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from './styles.less';

const PaxButton = (props) => {
    const { type, onClick, children, className, ...rest } = props;
    return (
        <button
            onClick={onClick}
            className={cx(
                styles.paxButton,
                styles[type],
                { [styles.withText]: !!children },
                className
            )
            }
        >
            {children}
        </button>
    )
};

PaxButton.types = {
    plus: 'plus',
    minus: 'minus',
    remove: 'remove'
};

const paxButtonTypesAsArray = Object.values(PaxButton.types);

PaxButton.defaultProps = {
    className: ''
};

PaxButton.propTypes = {
    type: PropTypes.oneOf(paxButtonTypesAsArray).isRequired,
    onClick: PropTypes.func.isRequired,
    className: PropTypes.string
};

export default PaxButton;


// WEBPACK FOOTER //
// ./src/components/PaxPart/PaxButton/PaxButton.js